/**
 * Utilidad para detectar información del dispositivo del usuario
 * Usado para auditoría de sesiones
 */

export interface DeviceInfo {
    navegador: string;
    sistemaOperativo: string;
    tipoDispositivo: string;
    modelo: string;
}

/**
 * Detecta el navegador del usuario
 */
function detectBrowser(): string {
    const ua = navigator.userAgent;

    if (ua.indexOf('Firefox') > -1) {
        const match = ua.match(/Firefox\/([0-9.]+)/);
        return match ? `Firefox ${match[1]}` : 'Firefox';
    }
    if (ua.indexOf('Edg') > -1) {
        const match = ua.match(/Edg\/([0-9.]+)/);
        return match ? `Edge ${match[1]}` : 'Edge';
    }
    if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) {
        const match = ua.match(/Chrome\/([0-9.]+)/);
        return match ? `Chrome ${match[1]}` : 'Chrome';
    }
    if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
        const match = ua.match(/Version\/([0-9.]+)/);
        return match ? `Safari ${match[1]}` : 'Safari';
    }

    return 'Desconocido';
}

/**
 * Detecta el sistema operativo del usuario
 */
function detectOS(): string {
    const ua = navigator.userAgent;

    if (ua.indexOf('Win') > -1) return 'Windows';
    if (ua.indexOf('Mac') > -1) return 'macOS';
    if (ua.indexOf('Linux') > -1) return 'Linux';
    if (ua.indexOf('Android') > -1) return 'Android';
    if (ua.indexOf('iOS') > -1 || ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1) {
        return 'iOS';
    }

    return 'Desconocido';
}

/**
 * Detecta el tipo de dispositivo
 */
function detectDeviceType(): string {
    const ua = navigator.userAgent;

    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    if (/Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
        return 'mobile';
    }

    return 'desktop';
}

/**
 * Detecta el modelo del dispositivo (simplificado)
 */
function detectModel(): string {
    const ua = navigator.userAgent;

    // iPhone
    if (ua.indexOf('iPhone') > -1) {
        return 'iPhone';
    }
    // iPad
    if (ua.indexOf('iPad') > -1) {
        return 'iPad';
    }
    // Android devices
    if (ua.indexOf('Android') > -1) {
        const match = ua.match(/Android.*Build\/([^;]+)/);
        return match ? match[1] : 'Android Device';
    }

    return 'Desktop';
}

/**
 * Obtiene toda la información del dispositivo
 */
export function getDeviceInfo(): DeviceInfo {
    return {
        navegador: detectBrowser(),
        sistemaOperativo: detectOS(),
        tipoDispositivo: detectDeviceType(),
        modelo: detectModel()
    };
}
